import React, { useState, useCallback } from "react";
import PaymentRepository from "assets/scripts/domain/payment/PaymentRepository";
import useRedux from "assets/scripts/hooks/useRedux";
import PayNowForm from "assets/scripts/components/forms/secure/PayNowForm/PayNowForm";
import { backToFront as acctBackToFront } from "assets/scripts/domain/accts/dataConversion";
import { groupAccountsAll } from "assets/scripts/components/containers/secure/Dashboard/groupAccounts";
import { ASYNC_STATE } from "assets/scripts/constants/Constants";
import { getRoutePaymentStatus } from "assets/scripts/domain/payment/paymentUtils";
import ImportantInformation from "assets/scripts/components/containers/secure/Dashboard/ImportantInformation/ImportantInformation";
import getUniqueDisclaimers from "assets/scripts/components/containers/secure/Dashboard/getUniqueDisclaimers";
import AuthRepository from "assets/scripts/domain/auth/AuthRepository";
import { ReceiptBase } from "../../secure/Receipt/Receipt";
export default function Payment(props) {
    const { account, email, token, setAccount, quickPayType } = props;
    const [rState] = useRedux(state => ({
        locale: state.i18n.locale
    }));
    const [step, setStep] = useState("payment");
    const [error, setError] = useState(null);
    const [paymentId, setPaymentId] = useState(null);
    const [receipt, setReceipt] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const createPayment = useCallback((payment) => {
        const doAsync = async () => {
            setError(null);
            let response;
            try {
                response = await PaymentRepository.createQuickPayment({
                    ...payment,
                    token
                });
            }
            catch (error) {
                setError(error);
                return;
            }
            if (response.success) {
                const { data } = response;
                if (data.type === "Success") {
                    setPaymentId(data.paymentId);
                    setReceipt(data.receipt);
                    return;
                }
                setAccount({
                    ...account,
                    paymentAllowedAt: data.paymentAvailableAt
                });
            }
        };
        setIsSaving(true);
        doAsync().then(() => setIsSaving(false));
    }, [token, account]);
    const frontEndAccounts = acctBackToFront({ accounts: [account] }).filter(it => !!it);
    const group = groupAccountsAll(frontEndAccounts, "en")[0];
    const { paymentAllowed, message } = getRoutePaymentStatus(group);
    const { disclaimers, disclaimerIdMap } = getUniqueDisclaimers(frontEndAccounts, rState.locale);
    if (receipt) {
        return (<ReceiptBase disableDone error={null} load={() => null} sendEmail={() => null} loadState={ASYNC_STATE.RESOLVED} needsLoad={false} receipt={receipt} params={{ paymentId: paymentId.toString() }}/>);
    }
    if (!paymentAllowed) {
        return (<div className={`wrapper ${process.env.FEATURE_PAYMENT_WIZARD ? "wrapper_narrowPlus" : "wrapper_medium"}`}>
				<div className="vr vr_x5">
					<span className="text error">
						{message}
					</span>
				</div>
				<div style={{ marginTop: "20px" }}>
					<ImportantInformation disclaimers={disclaimers} disclaimerIdMap={disclaimerIdMap}/>
				</div>
			</div>);
    }
    return (<div className={`wrapper ${process.env.FEATURE_PAYMENT_WIZARD ? "wrapper_narrowPlus" : "wrapper_medium"}`}>
			<PayNowForm disableBankSave key={account.id.toString()} error={error} group={group} isSaving={isSaving} onCreatePayment={createPayment} onStepBack={s => setStep(s)} onStepForward={s => setStep(s)} step={step} hideDate={quickPayType === "Dashboard"} hideEmail={quickPayType === "Dashboard"} validateAmount={quickPayType === "Email"
        ? undefined
        : amount => AuthRepository.checkQuickPayAmount(token, amount).then(r => r.success && r.data)} profile={{
        address: "",
        address2: "",
        bankAccounts: [],
        city: "",
        email,
        firstName: "",
        lastName: "",
        initialDeceased: false,
        isComplete: true,
        okEmail: "no",
        phoneCell: "",
        phoneHome: "",
        phoneWork: "",
        phoneWorkExt: "",
        preferredPhone: "Home",
        state: "",
        zip: ""
    }}/>
			<div style={{ marginTop: "20px" }}>
				<ImportantInformation disclaimers={disclaimers} disclaimerIdMap={disclaimerIdMap}/>
			</div>
		</div>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/QuickPay/Payment.tsx